import { LIMITE_REVENTE_TOTALE, ModeConsommation } from '../../services/calculs/calculPhotovoltaique';
import { PackageData_PaneauPhotovoltaique } from '../../services/calculs/package';
import { Labelled } from '../../services/tools/TypeHelper';

export const getModeConsommationList = (pvPack: PackageData_PaneauPhotovoltaique): Array<Labelled<ModeConsommation>> => {
    return pvPack.mainProduct === undefined ||
        !pvPack.mainProduct.puissance ||
        pvPack.mainProduct.puissance === 0 ||
        pvPack.puissance === undefined ||
        pvPack.puissance === 0 ||
        pvPack.puissance <= LIMITE_REVENTE_TOTALE
        ? modeConsommationList_bas
        : modeConsommationList_haut;
};

export const modeConsommationList_bas: Array<Labelled<ModeConsommation>> = [
    {
        label: 'Autoconsommation',
        value: 'Autoconsommation',
    },
    {
        label: 'Revente en surplus',
        value: 'ReventeSurplus',
    },
];
// On ne reprend pas celle du bas, car il faut que la première soit celle par défaut.
export const modeConsommationList_haut: Array<Labelled<ModeConsommation>> = [
    {
        label: 'Revente en surplus',
        value: 'ReventeSurplus',
    },
    {
        label: 'Revente totale',
        value: 'ReventeTotale',
    },
    {
        label: 'Autoconsommation',
        value: 'Autoconsommation',
    },
];

/** Légendes des couelurs du graphique hsitogramme Avant/Après, dans le SimulatorContainer */
export const legendList: { text: string; class: string; id: number }[] = [
    {
        id: 0,
        text: 'Chauffage',
        class: 'chauffage',
    },
    {
        id: 1,
        text: 'Eau chaude sanitaire',
        class: 'eau',
    },
    {
        id: 2,
        text: 'Electricité ménagère',
        class: 'electricite',
    },
    {
        id: 3,
        text: 'Abonnement Electricité',
        class: 'abonnement-electricite',
    },
    {
        id: 4,
        text: 'Abonnement Gaz',
        class: 'abonnement-gaz',
    },
];
